import { Component, h, Host, Prop, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-image-text-float',
    styleUrl: 'sew-ws-image-text-float.scss',
    shadow: false,
})
export class SewWsImageTextFloat {
    @Element() host: HTMLSewWsImageTextFloatElement;

    @Prop({ reflect: true }) noGrid = false;
    @Prop({ reflect: true }) noMargin = false;
    @Prop({ reflect: true }) reverse = false;
    @Prop() headline: string;

    render() {
        return (
            <Host>
                <div class="main-content-container">
                    {this.headline && <h2 class="headline" innerHTML={this.headline}></h2>}
                    <slot />
                </div>
            </Host>
        );
    }
}
